<template>
  <div>
    <div id="app" :keydown="handleKeyup" :class="{ 'overflow-hidden': isScrollHidden }">
      <ConfigProvider :locale="ja_JP">
        <!-- <keep-alive> -->
          <router-view></router-view>
        <!-- </keep-alive> -->
      </ConfigProvider>
    </div>
    <div class="app-spinner" v-if="loading">
      <a-spin :spinning="loading" size="large"/>
    </div>
  </div>
</template>

<script>
import { ConfigProvider } from 'ant-design-vue'
import jaJP from 'ant-design-vue/es/locale/ja_JP'
import moment from 'moment'
import _ from 'lodash'

moment.locale('ja')

export default {
  name: 'app',
  components: {
    ConfigProvider
  },
  setup() {
    return {
    }
  },
  data() {
    return {
      ja_JP: jaJP,
      loading: true,
      language: 'jp',
      popupRefresh: false,
      confirmReload: false,
      timer: null
    }
  },
  mounted() {
    this.loading = false
    // wovnの状態の受け渡し
    window.addEventListener('wovnApiReady', () => {
      this.language = this.$wovn.getLang
    })
    window.addEventListener('wovnLangChanged', () => {
      this.language = this.$wovn.getLang
    })
    
    // 
    window.addEventListener('keydown', ($event) => {
      const context = this
      const fullUrlParams = {...this.$route.params, ...this.$route.query}
      if ($event.key === 'F5') {
        const onRefesh = _.get(this.$route.meta, 'onRefesh', {})
        const confirm = _.get(this.$route.meta, 'onRefesh.confirm', false)
        if (!confirm) {
          return true
        } else {
          if (!this.popupRefresh) {
            this.popupRefresh = true
            // open popup confirm
            this.$confirm({
              title: '前の画面に戻ります。よろしいでしょうか？',
              content: '',
              okText: 'はい',
              cancelText: 'いいえ',
              class: 'modal-confirm-custom',
              onOk() {
                context.popupRefresh = false
                switch(onRefesh.redirectOnConfirm) {
                case 'plan_details':
                  context.hrefUrlPlanDetails(fullUrlParams)
                  break
                }
              },
              onCancel() {
                context.popupRefresh = false
              }
            })
          }
          $event.preventDefault()
          return false
        }
      }
    })

    window.addEventListener("pagehide", () => {
      if(_.get(this.$route.meta, 'bs_app')){
        sessionStorage.setItem("bs_app", (JSON.stringify(this.$store.state.bs_app)));
      }
    }, false );

    window.onbeforeunload = ($event) => {
      // const onRefesh = _.get(this.$route.meta, 'onRefesh', {})
      const confirm = _.get(this.$route.meta, 'onRefesh.confirm', false)
      if (confirm) {
        $event.preventDefault()
        return false
      }

      if (this.confirmReload) {
        $event.preventDefault()
        return false
      }
    }
    this.setHeight();
    this.setEvent();
    window.addEventListener('resize', this.setScreen);
    this.setScreen();
  },
  watch: {
    '$store.state.loading'(loading) {
      this.loading = loading
    },
    '$store.state.confirmReload'(confirm) {
      this.confirmReload = confirm
    },
    isScrollHidden(val) {
      if (val) {
        document
          .getElementsByTagName("html")[0]
          .classList.add("crly-overflow-hidden");
      } else {
        document
          .getElementsByTagName("html")[0]
          .classList.remove("crly-overflow-hidden");
      }
    }
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    handleKeyup($event) {
    },
    hrefUrlPlanDetails(params) {
      let url = `${location.protocol}//${location.host}/menus/${params.menuNo}/plans/${params.planId}/rooms/${params.roomId}`
      if (params.adultHeadCnt) {
        url += url.indexOf('?') > 0 ? `&adultHeadCnt=${params.adultHeadCnt}` : `?adultHeadCnt=${params.adultHeadCnt}`
      }
      if (params.checkInDate) {
        url += url.indexOf('?') > 0 ? `&checkInDate=${params.checkInDate}` : `?checkInDate=${params.checkInDate}`
      }
      if (params.stayNights) {
        url += url.indexOf('?') > 0 ? `&stayNights=${params.stayNights}` : `?stayNights=${params.stayNights}`
      }
      location.href = url
    },
    setScreen() {
        const width = window.innerWidth;
        const type = width < 639 ? 'mobile' : 'desktop';
        this.$store.commit('SET_SCREEN', type);
    },
    setter(height) {
      const customProperty = "--height";
      document.documentElement.style.setProperty(customProperty, height);
    },
    setHeight() {
      if (this.isAndroid) {
        this.setter(`${window.innerHeight}px`);
      } else if (this.isIOS) {
        if (this.iOSVersion >= 15.4) {
          this.setter(`100dvh`);
        } else if (this.iOSVersion >= 15) {
          this.setter(`100vh`);
        } else {
          this.setter(`${window.innerHeight}px`);
        }
      } else {
        this.setter("100vh");
      }
      clearTimeout(this.timer);
      this.timer = null;
    },
    timerEvent() {
      if (this.timer) {
        return;
      }
      this.timer = window.setTimeout(this.setHeight, 200);
    },
    setEvent() {
      window.addEventListener("resize", this.timerEvent);
    }
  },
  computed: {
    isScrollHidden() {
      if (
        this.$store.getters["menuStatus/getCategoryMenu"] ||
        this.$store.getters["menuStatus/getSlideMenu"]
      ) {
        return true;
      }
      return false;
    },
    isAndroid() {
      const ua = navigator.userAgent;
      if (/android/i.test(ua)) {
        return true;
      }
      return false;
    },
    isIOS() {
      const ua = navigator.userAgent;
      if (/iP(hone|(o|a)d)/.test(ua)) {
        return true;
      }
      return false;
    },
    iOSVersion() {
      const ua = navigator.userAgent;
      return (
        parseFloat(
          (
            "" +
            (/CPU.*OS ([0-9_]{1,5})|(CPU like).*AppleWebKit.*Mobile/i.exec(
              ua
            ) || [0, ""])[1]
          )
            .replace("undefined", "3_2")
            .replace("_", ".")
            .replace("_", "")
        ) || false
      );
    }
  },
  destroyed() {
    window.removeEventListener("resize", this.timerEvent);
    clearTimeout(this.timer);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setScreen);
  }
}
</script>

<style lang="scss" scoped>
@font-face {
  font-family: "Noto Sans JP";
  src: local("Merienda"),
   url(./assets/fonts/NotoSansJP-Regular.otf) format("truetype");
}
#app {
  // ライフエールstay独自対応
  // font-family: "Noto Sans JP", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #1f2021;
  font-size: 14px;
  height: 100vh;

  &.overflow-hidden {
    @include mq() {
      overflow-y: hidden;
    }
  }
}
.app-spinner {
  position: fixed;
  top: 0px;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  // background: rgb(0 0 0 / 10%);
  background: rgba(0, 0, 0, 0.1);
  z-index: 999999;
  transition: 1s;
}

/* ↓↓ライフエール独自対応↓↓ */
#app {
  height: calc(var(--height) - 50px)
}
/* ↑↑ライフエール独自対応↑↑ */
</style>
